import { ReactElement } from 'react';

import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';

import { Box, Typography, SxProps, Theme } from '@mui/material';

import { formatMoney } from './formatUtils';
import { SmallScholarship } from './types';

const { AWARD_INFO } = appStrings.modules.nugget.scholarship;

type NuggetScholarshipSmallProps = Readonly<{
  variant: SmallScholarship;
  contentSize?: 'SMALL' | 'LARGE';
}>;

export function NuggetScholarshipSmall({
  variant,
  contentSize = 'LARGE',
}: NuggetScholarshipSmallProps): ReactElement {
  const awardRangeMin = formatMoney(variant.awardMoneyRangeMin);

  const awardRangeMax = variant.awardMoneyRangeMax
    ? ` - ${formatMoney(variant.awardMoneyRangeMax)}`
    : '';

  const titleStyles = contentSize === 'SMALL' ? smallTextStyle : textStyle;

  return (
    <Box my={2}>
      {(awardRangeMin || awardRangeMax) && (
        <Typography variant="body1" sx={titleStyles}>
          <em>{AWARD_INFO.AWARD_RANGE}</em> {awardRangeMin}
          {awardRangeMax}
        </Typography>
      )}
      {variant.awardType && (
        <Typography variant="body1" sx={titleStyles}>
          <em>{AWARD_INFO.AWARD_TYPE}</em> {variant.awardType}
        </Typography>
      )}
      {variant.awardCategory && (
        <Typography variant="body1" sx={titleStyles}>
          <em>{AWARD_INFO.AWARD_CATEGORY}</em> {variant.awardCategory}
        </Typography>
      )}
      {variant.awardDeadline && (
        <Typography variant="body1" sx={titleStyles}>
          <em>{AWARD_INFO.APPLICATION_DEADLINE}</em> {variant.awardDeadline}
        </Typography>
      )}
    </Box>
  );
}

export const textStyle: SxProps<Theme> = {
  fontFamily: 'Sarabun',
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '20px',
  mt: 1,
};

export const smallTextStyle: SxProps<Theme> = {
  fontFamily: 'Sarabun',
  fontSize: '15px',
  fontWeight: 400,
  lineHeight: '18px',
  mt: 0.5,
};
